var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanPrice02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.4865,
    height: 38,
    fill: "#1B2E6B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4863,
    width: 19.5135,
    height: 38,
    fill: "#B8B1FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4863,
    y: 18.4863,
    width: 19.5135,
    height: 19.5135,
    fill: "#DCD8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanPrice02);
export default __webpack_public_path__ + "static/media/plan-price-02.38a636c07bcade9b00b448a8913e2a9d.svg";
export { ForwardRef as ReactComponent };